import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export const SSOAuth = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { ssoAuthenticate, socialLogin } = useAuth()

  useEffect(() => {
    const getQueryParam = (name: string) => {
      const searchParams = new URLSearchParams(location.search)
      return searchParams.get(name)
    }

    const token = getQueryParam('token')
    const code = getQueryParam('code')
    const verifier = sessionStorage.getItem('code_verifier')
    const state = getQueryParam('state')
    const error = getQueryParam('error')
    // Handle OAuth error
    if (error) {
      console.error('OAuth error:', error)
      navigate('/login?error=oauth_failed')
      return
    }

    // Handle excalibrr SSO callback with token
    if (token) {
      ssoAuthenticate(token).then((isLoggedIn) => {
        if (isLoggedIn) {
          navigate('/integration-management/overview')
        }
      })
      return
    }

    // Handle OAuth authorization code flow
    if (code && state && verifier) {
      // Use the socialLogin function with the authorization code
      console.log('OAuth code received, processing login')

      socialLogin('google', {
        code,
        verifier,
        state,
        redirect_uri: `${window.location.origin}/ssoAuth`,
      })
        .then(() => {
          navigate('/integration-management/overview')
        })
        .catch((error) => {
          console.error('OAuth login error:', error)
          navigate('/login?error=oauth_failed')
        })

      return
    }

    // If no parameters found, redirect to login
    navigate('/login')
  }, [])

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Authenticating...</h1>
      <p>Please wait while we log you in.</p>
    </div>
  )
}
